import axios from 'axios';
import { loginreq, req } from './axiosFun';
import config from './config';

let url = config.apiBase
// let url = 'http://parse.huanyings.com/api-clone'
  // let url = 'http://appphone.xgost.com/api'  //云手机正式  //云手机Order支付类型解除注释
// 登录接口
export const login = (params) => { return loginreq("post", "/api/login", params) };
export const loginAdd = (params) => { return axios.post(url + "/admin/web/login", params) };

// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => { return axios.delete("/api/login?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };

//根据手机号获取用户信息
export const getUserInfo = (params) => { return req("post", url + "/admin/web/getUserInfo", params) };

export const vipList = (params) => { return req("post", url + "/admin/web/customerPage", params) };
export const vpnAreaPage = (params) => { return req("post", url + "/admin/vpnAreaPage", params) };
export const userCrashPay = (params) => { return req("post", url + "/admin/userCrashPay", params) };
export const userCrashPage = (params) => { return req("post", url + "/admin/userCrashPage", params) };
export const cityVoteResult = (params) => { return req("post", url + "/report/cityVoteResult", params) };
export const linkCountOnLine = (params) => { return req("post", url + "/report/linkCountOnLine", params) };
export const vpnRefreshTime = (params) => { return req("post", url + "/report/vpnRefreshTime", params) };
export const vpnLineUpdate = (params) => { return req("post", url + "/admin/vpnLineUpdate", params) };
//获取省
export const vpnAreaFirstList = (params) => { return req("post", url + "/admin/vpnAreaFirstList", params) };
//获取市
export const vpnAreaSecendList = (params) => { return req("post", url + "/admin/vpnAreaFirstList", params) };
// 添加线路

export const vpnLineAdd = (params) => { return req("post", url + "/admin/vpnLineAdd", params) };
// 云手机激活码分页
export const actCodePage = (params) => { return req("post", url + "/admin/actCodePage", params) };
// 生成激活码

export const actCodeCreate = (params) => { return req("post", url + "/admin/actCodeCreate", params) };
// X空间作废激活码

export const actCodeDestroy = (params) => { return req("post", url + "/admin/actCodeDestroy", params) };
// X空间激活码获取用户详情

export const userDetail = (params) => { return req("post", url + "/admin/userDetail", params) };
// X空间试用激活码

export const actCodeUse = (params) => { return req("post", url + "/admin/actCodeUse", params) };
// X空间激活码统计
export const actCodeReportPage = (params) => { return req("post", url + "/admin/actCodeReportPage", params) };

// HC批量添加账号
export const customerCreateBatch = (params) => { return req("post", url + "/admin/customerCreateBatch", params) };
// x空间 用户管理 密码修改

export const customerChangePass = (params) => { return req("post", url + "/admin/customerChangePass", params) };
export const customerInvitePage = (params) => { return req("post", url + "/admin/customerInvitePage", params) };

// 用户详情（全部字段）
export const getUserDetail = (params) => { return req("get", url + "/admin/web/getUserDetail", params) };
// 更新用户
export const updateUser = (params) => { return req("post", url + "/admin/web/updateUser", params) };
// 清除用户登录状态
export const cleanUserToken = (params) => { return req("get", url + "/admin/web/cleanUserToken", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js